import type { PaymentGateway, PaymentMethodUsage, PaymentType } from '@change-corgi/middle-end-gql-schema';

import type { PaymentType as TrackingPaymentType } from 'src/app/shared/utils/payments';
import { paymentMethod as getPaymentMethod } from 'src/app/shared/utils/payments';

import { useDeviceData } from './useDeviceData';
import { useSetupFutureUsage } from './useSetupFutureUsage';

type PaymentMethod = {
	gateway: PaymentGateway;
	token?: string;
	type: PaymentType;
	setupFutureUsage?: PaymentMethodUsage;
	deviceData?: string | null;
};

export function usePromotionChargePaymentMethod(): (paymentType: TrackingPaymentType, token?: string) => PaymentMethod {
	const setupFutureUsage = useSetupFutureUsage();
	const getDeviceData = useDeviceData();

	return function promotionChargePaymentMethod(paymentType, token) {
		const paymentMethod = getPaymentMethod(paymentType, token);
		return {
			...paymentMethod,
			...setupFutureUsage(paymentMethod.gateway, paymentType),
			...getDeviceData(paymentType),
		};
	};
}
